import type { ReactNode } from 'react'
import { NavLink } from 'react-router-dom'

const NAV = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/compare', label: 'Comparison Explorer' },
  { to: '/trends', label: 'Trends' },
  { to: '/competitors', label: 'Competitors' },
  { to: '/admin', label: 'Admin' },
]

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-offwhite text-ink">
      <header className="border-b border-oxblood/10 bg-blush/40">
        <div className="mx-auto max-w-7xl px-6 pt-7">
          <p className="font-body text-[11px] uppercase tracking-[0.3em] text-oxblood/70">Daniella AIOS</p>
          <h1 className="mt-1 font-display text-3xl text-oxblood">Competitor Intel Tracker</h1>
          <p className="font-body text-sm text-ink/50">Wedding band pricing intelligence</p>
          <nav className="mt-4 flex flex-wrap gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) =>
                  `rounded-t-md px-4 py-2 font-body text-sm transition-colors ${
                    isActive
                      ? 'bg-white/70 font-medium text-oxblood'
                      : 'text-ink/50 hover:text-oxblood'
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-6 py-8">{children}</main>
    </div>
  )
}
